<template>
  <div class="relative h-full w-full flex flex-wrap justify-between items-end border-b-2 border-primary-medium">
    <header class="w-full text-sm font-bold pb-2">{{ label }}</header>
    <input v-model="q" type="search" placeholder="" class="w-full mr-6 focus:outline-none">
    <div class="absolute right-0 bottom-0 pr-2">
      <font-awesome-icon :icon="['fas', 'search']" size="sm"/>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    q: null,
  }),
  watch: {
    q() {
      this.$emit('input', this.q);
    },
  },
};
</script>
